module.exports = __webpack_public_path__ + "static/media/checkbox_toggle_white.32e35c1f.svg";